/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import ValidateItem from "../../../helpers/validation/validateInput";
import RangeSlider from "../../ui/RangeSlider";
import { SketchPicker } from "react-color";
import { Checkboard } from "react-color/lib/components/common";

class GradientInput extends Component {
	constructor(props) {
		super(props);

		this.step = props.step ? props.step : 1;
		this.min = props.min ? props.min : 0;
		this.max = props.max ? props.max : 100;
		this.state = {
			minimizePlaceholder: false,
			value: props.fieldState.initialValue,
			showPicker: false,
			showColorPicker: false,
			dragObject: null,
			dragging: false,
			rel: 0,
			colorBarLeft: 0,
			moved: false,
			rgba: {
				r: 41,
				g: 47,
				b: 193,
				a: 1,
			},
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.dragging && !prevState.dragging) {
			document.addEventListener("mousemove", this.onMouseMove);
			document.addEventListener("mouseup", this.onMouseUp);
		} else if (!this.state.dragging && prevState.dragging) {
			document.removeEventListener("mousemove", this.onMouseMove);
			document.removeEventListener("mouseup", this.onMouseUp);
		}
	}

	onMouseDown = (e, index) => {
		// only left mouse button
		if (e.button !== 0) return;
		var rel = this.getElementOffset(e.target).left;
		var colorBarLeft = this.getElementOffset(this.colorBar).left;
		this.setState({
			dragging: true,
			rel,
			colorBarLeft,
			dragObject: index,
		});
		e.stopPropagation();
		e.preventDefault();
	};

	onMouseUp = e => {
		if (!this.state.moved) {
			let { color } = this.props.fieldState.value.parts[this.state.dragObject];
			let parts = color
				.substring(5, color.length - 1)
				.replace(/ /g, "")
				.split(",");
			let rgba = {
				r: parts[0],
				g: parts[1],
				b: parts[2],
				a: parts[3],
			};
			this.setState({ showColorPicker: true, rgba });
		}
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: { direction: 0, parts: [] };
		newValue.parts.sort(this.sortParts);
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
		this.setState({ dragging: false, moved: false });
		e.stopPropagation();
		e.preventDefault();
	};

	onMouseMove = e => {
		if (!this.state.dragging) return;
		var barWidth = this.colorBar.offsetWidth;
		let fromLeft = e.pageX - this.state.colorBarLeft;
		if (fromLeft < 0) {
			fromLeft = 0;
		} else if (fromLeft > barWidth) {
			fromLeft = barWidth;
		}
		let val = (fromLeft / barWidth) * 100;
		this.changeColorPercent(this.state.dragObject, val);
		if (!this.state.moved) {
			this.setState({ moved: true });
		}
		e.stopPropagation();
		e.preventDefault();
	};

	getElementOffset = element => {
		var de = document.documentElement;
		var box = element.getBoundingClientRect();
		var top = box.top + window.pageYOffset - de.clientTop;
		var left = box.left + window.pageXOffset - de.clientLeft;
		return { top: top, left: left };
	};

	validate = value => {
		const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
		return ValidateItem(value, placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage);
	};

	sortParts = (a, b) => {
		return a.percent > b.percent ? 1 : -1;
	};

	updateValue = newValue => {
		if (newValue > this.props.max) {
			newValue = this.props.max;
		} else if (newValue < this.props.min) {
			newValue = this.props.min;
		}
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	togglePicker = () => {
		this.setState({ showPicker: !this.state.showPicker });
	};

	toggleColorPicker = () => {
		this.setState({ showColorPicker: !this.state.showColorPicker });
	};

	changeDirection = value => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: { parts: [{ color: "rgba(41,47,193,1)", percent: 0 }, { color: "rgba(0,115,184,1)", percent: 100 }] };
		newValue.direction = value;
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	changeColorPercent = (index, percent) => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: { direction: 0, parts: [] };
		newValue.parts[index].percent = percent;
		//newValue.parts.sort(this.sortParts);
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	handleColorChange = color => {
		let { r, g, b, a } = color.rgb;
		this.setState({ rgba: color.rgb });
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: { direction: 0, parts: [] };
		newValue.parts[this.state.dragObject].color = `rgba(${r},${g},${b},${a})`;
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	addColor = event => {
		let left = this.getElementOffset(this.colorBar).left;
		var percent = ((event.clientX - left) / this.colorBar.offsetWidth) * 100;
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: { direction: 0, parts: [] };
		newValue.parts.push({ color: "rgba(50,50,50,1)", percent });
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	removeColor = () => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: { direction: 0, parts: [] };
		newValue.parts.splice(this.state.dragObject, 1);
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
		this.toggleColorPicker();
	};

	removeGradient = () => {
		this.props.fieldApi.setValue(null);
		this.props.fieldApi.setTouched(true);
		this.togglePicker();
	};

	reverseColors = () => {
		let newValue = this.props.fieldState.value
			? Object.assign({}, this.props.fieldState.value)
			: { direction: 0, parts: [] };
		newValue.parts.forEach(part => {
			part.percent = 100 - part.percent;
		});
		newValue.parts.sort(this.sortParts);
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	render() {
		const { fieldState, placeholder, isRequired } = this.props;
		const { value, error } = fieldState;
		const shouldFocus = value && value !== "";
		const isFocused = shouldFocus ? " focus" : "";
		const hasError = error ? " has-error" : "";
		//const directionError = value && value.direction ? (isNaN(value) ? " has-error" : "") : "";
		let directionValue = 0;
		let colors = [];
		let colorPreview = "";
		if (value) {
			directionValue = value.direction;
			colors = value.parts.map((part, index) => (
				<div
					className="gradient-slider-item"
					key={index}
					onMouseDown={e => this.onMouseDown(e, index)}
					style={{ backgroundColor: part.color, left: `${part.percent}%` }}
				></div>
			));
			let newParts = value.parts.concat();
			let colorParts = newParts.sort(this.sortParts).map(part => `${part.color} ${part.percent}%`);
			colorPreview = `linear-gradient(${directionValue}deg, ${colorParts.join(", ")})`;
		}

		return (
			<div className="color-picker-input">
				<div className={`input-wrap${isFocused}${hasError}`}>
					<div className="placeholder">
						<span className={shouldFocus ? "caption-text" : ""}>
							{isRequired && <span className="isrequired-label">*</span>}
							{placeholder}
						</span>
					</div>
					<input className="dummy-input" onFocus={() => this.togglePicker()} />
					<div className="color-picker-value" onClick={() => this.togglePicker()}>
						<div style={{ background: colorPreview }}></div>
					</div>
					<div
						className={`coverall ${this.state.showPicker ? "on" : ""}`}
						onClick={() => this.togglePicker()}
					></div>
					<div className={`input-modal ${this.state.showPicker ? "on" : "off"}`}>
						<div className="gradient-preview">
							<Checkboard size={12} white="#ffffff" grey="#cccccc" />
							<div className="gradient-preview-colors" style={{ background: colorPreview }}></div>
						</div>
						<div>
							<div
								className="gradient-slider"
								ref={r => {
									this.colorBar = r;
								}}
								onMouseDown={this.addColor}
							>
								{colors}
							</div>
							<div className="reverse-btn" onClick={this.reverseColors}>
								<i className="fal fa-exchange"></i>
							</div>
						</div>
						<RangeSlider
							onChange={this.changeDirection}
							value={directionValue}
							min={0}
							max={180}
							placeholder="Direction"
						/>
						<div
							className={`coverall ${this.state.showColorPicker ? "on" : ""}`}
							onClick={() => this.toggleColorPicker()}
						></div>
						<div className={`input-modal ${this.state.showColorPicker ? "on" : "off"}`}>
							<SketchPicker
								color={this.state.rgba}
								presetColors={[]}
								onChangeComplete={this.handleColorChange}
							/>
							<div className="btn btn-primary wide m-top" onClick={this.removeColor}>
								Remove
							</div>
						</div>
						<div className="btn btn-primary wide m-top" onClick={this.removeGradient}>
							Clear Gradient
						</div>
					</div>
				</div>
			</div>
		);
	}
}

GradientInput.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	themeId: PropTypes.string,
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
};

const Wrapper = asField(({ fieldState, ...props }) => <GradientInput fieldState={fieldState} {...props} />);

export default Wrapper;
